import React from 'react';

const SvgWarehouses = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path
      d="M16.52 3.89H4.07a.7.7 0 00-.7.71v14.8a.7.7 0 00.7.71h15.86a.71.71 0 00.71-.71V8a4.13 4.13 0 00-4.12-4.11zM14.89 18.7h-2.18v-6h2.18zm-3.59 0H9v-6h2.3zm7.92 0H16.3V12a.7.7 0 00-.71-.7H8.27a.7.7 0 00-.7.7v6.7H4.78V5.3h11.75A2.71 2.71 0 0119.22 8z"
      fill="#989898"
    />
  </svg>
);

export default SvgWarehouses;
